export const environment = {
  production: false,
  analyticsTagSrc: 'https://tags.nationwide.com/test/Bootstrap.js',
  ci: false,
  imports: [],
};
